<template>
  <div>
    <v-btn depressed color="primary" @click="downloadListDoctors">
      <v-icon class="mr-4">mdi-download</v-icon>
      Lista lekarzy
    </v-btn>
    <v-btn class="ml-2" depressed color="" @click="sendPush">
      <v-icon class="mr-4">mdi-email-send-outline</v-icon>
      Wyślij powiadomienie
    </v-btn>
    {{ d }}
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Szukaj"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table :headers="headers" :items="data" :search="search" :item-class="itemRowClass">
      <template v-slot:[`header.agreement_commercial_1`]="{ header }">
        <v-icon>mdi-email</v-icon> {{ header.text }}
      </template>
      <template v-slot:[`header.agreement_commercial_2`]="{ header }">
        <v-icon>mdi-phone</v-icon> {{ header.text }}
      </template>
      <template v-slot:[`header.agreement_non_commercial_1`]="{ header }">
        <v-icon>mdi-email</v-icon> {{ header.text }}
      </template>
      <template v-slot:[`header.agreement_non_commercial_2`]="{ header }">
        <v-icon>mdi-phone</v-icon> {{ header.text }}
      </template>
      <template v-slot:[`header.mobile`]="{ header }">
        <v-icon>mdi-cellphone</v-icon> {{ header.text }}
      </template>
      <template v-slot:[`header.agreement_email`]="{ header }">
        <v-icon>mdi-email</v-icon> {{ header.text }}
      </template>
      <template v-slot:[`header.agreement_phone`]="{ header }">
        <v-icon>mdi-phone</v-icon> {{ header.text }}
      </template>
      <template v-slot:[`item.registration_data`]="{ item }">
        <span class="nowrap">{{ getDate(item.registration_data) }}</span>
      </template>
      <template v-slot:[`item.phone`]="{ item }">
        <span class="nowrap">{{ item.phone }}</span>
      </template>
      <template v-slot:[`item.mobile`]="{ item }">
        <v-icon :color="item.mobile ? 'green' : 'red'">
          {{
            item.mobile
              ? "mdi-checkbox-marked-circle-outline"
              : "mdi-close-circle-outline"
          }}
        </v-icon>
      </template>
      <template v-slot:[`item.agreement_commercial_1`]="{ item }">
        <v-icon :color="item.agreement_commercial_1 ? 'green' : 'red'">
          {{
            item.agreement_commercial_1
              ? "mdi-checkbox-marked-circle-outline"
              : "mdi-close-circle-outline"
          }}
        </v-icon>
      </template>
      <template v-slot:[`item.agreement_commercial_2`]="{ item }">
        <v-icon :color="item.agreement_commercial_2 ? 'green' : 'red'">
          {{
            item.agreement_commercial_2
              ? "mdi-checkbox-marked-circle-outline"
              : "mdi-close-circle-outline"
          }}
        </v-icon>
      </template>
      <template v-slot:[`item.agreement_non_commercial_1`]="{ item }">
        <v-icon :color="item.agreement_non_commercial_1 ? 'green' : 'red'">
          {{
            item.agreement_non_commercial_1
              ? "mdi-checkbox-marked-circle-outline"
              : "mdi-close-circle-outline"
          }}
        </v-icon>
      </template>
      <template v-slot:[`item.agreement_non_commercial_2`]="{ item }">
        <v-icon :color="item.agreement_non_commercial_2 ? 'green' : 'red'">
          {{
            item.agreement_non_commercial_2
              ? "mdi-checkbox-marked-circle-outline"
              : "mdi-close-circle-outline"
          }}
        </v-icon>
      </template>
      <template v-slot:[`item.agreement_email`]="{ item }">
        <v-icon :color="item.agreement_email ? 'green' : 'red'">
          {{
            item.agreement_email
              ? "mdi-checkbox-marked-circle-outline"
              : "mdi-close-circle-outline"
          }}
        </v-icon>
      </template>
      <template v-slot:[`item.agreement_phone`]="{ item }">
        <v-icon :color="item.agreement_phone ? 'green' : 'red'">
          {{
            item.agreement_phone
              ? "mdi-checkbox-marked-circle-outline"
              : "mdi-close-circle-outline"
          }}
        </v-icon>
      </template>
      <template v-slot:[`item.verify`]="{ item }">
        <v-chip label dark small :color="item.verify ? 'green' : 'red'">
          {{ item.verify ? "Aktywny" : "Nieaktywny" }}
        </v-chip>
      </template>
      <template v-slot:[`item.options`]="{ item }">
        <v-row align="center" justify="space-around">
          <v-btn color="primary" @click="userOptions(item)">
            <v-icon>
              mdi-account-edit
            </v-icon>
          </v-btn>
          <v-btn color="error" @click="deleteDoctor(item.id)">
            <v-icon>
              mdi-account-remove
            </v-icon>
          </v-btn>
        </v-row>
      </template>
    </v-data-table>
    <InfoModal
      :admin="admin"
      :open="open"
      :userInfo="userInfo"
      @close="close"
    />
    <DoctorSendNotify
      :open="sendNotifyOpen"
      @close="sendNotifyClose"
    />
    <Snackbar :snackbar="snackbar" :snackbarStatus="snackbarStatus" />
  </div>
</template>

<script>
import axiosConf from "../../axios-conf";
import FileSaver from "file-saver";
import InfoModal from "@/components/InfoModal.vue";
import DoctorSendNotify from "@/components/DoctorSendNotify.vue";
import Snackbar from "@/components/Snackbar.vue";

export default {
  components: {
    InfoModal,
    DoctorSendNotify,
    Snackbar
  },
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Imię",
          value: "firstname"
        },
        { text: "Nazwisko", value: "lastname" },
        { text: "Numer PWZ", value: "pwz" },
        { text: "E-mail", value: "email" },
        { text: "Telefon", value: "phone" },
        { text: "Data Rejestracji", value: "registration_data" },
        { text: "E-TX", value: "mobile", align: "center" },
        { text: "H", value: "agreement_commercial_1", align: "center" },
        { text: "H", value: "agreement_commercial_2", align: "center" },
        {
          text: "NH",
          value: "agreement_non_commercial_1",
          align: "center"
        },
        {
          text: "NH",
          value: "agreement_non_commercial_2",
          align: "center"
        },
        { text: "A", value: "agreement_email", align: "center" },
        { text: "A", value: "agreement_phone", align: "center" },
        { text: "Status", value: "verify" },
        { text: "Opcje", value: "options" }
      ],
      data: [],
      open: false,
      sendNotifyOpen: false,
      admin: false,
      userInfo: [],
      snackbar: false,
      snackbarStatus: false,
      d: null
    };
  },
  methods: {
    modalOpen(edit) {
      if (!edit) {
        this.userInfo = [];
      }
      this.open = true;
    },
    close(status) {
      if (status !== "close") {
        this.snackbar = true;
        this.snackbarStatus = status;
        this.getData();
      }
      this.open = false;
    },
    userOptions(user) {
      this.userInfo = user;
      this.modalOpen(true);
    },
    itemRowClass(item){
      return item.confirmed ? '' : 'yellow lighten-4';
    },
    getData() {
      axiosConf
        .get("doctors.json", {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("loggedIn")}`
          }
        })
        .then(response => {
          this.data = [...response.data];
        });
    },
    deleteDoctor(userId){
      if(! confirm("Czy na pewno chcesz usunąć użytkownika?")){
        return;
      }
      axiosConf.delete(`doctor/${userId}.json`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("loggedIn")}`
        }
      }).then(() => {
        this.data.splice(0, this.data.length)
        this.getData()
      })
    },
    getDate(date) {
      if (date == null) {
        return "";
      } else {
        const getDate = new Date(date);
        const day =
          getDate.getDate(date) < 10
            ? `0${getDate.getDate(date)}`
            : getDate.getDate(date);
        const month =
          getDate.getMonth(date) + 1 < 10
            ? `0${getDate.getMonth(date) + 1}`
            : getDate.getMonth(date) + 1;
        const year = getDate.getFullYear(date);
        return `${day}-${month}-${year}`;
      }
    },
    downloadListDoctors(e) {
      e.preventDefault();
      axiosConf
        .get("doctors.csv", {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("loggedIn")}`
          }
        })
        .then(response => {
          const BOM = "\uFEFF";
          const csvData = BOM + response.data;
          const blob = new Blob([csvData], { type: "text/csv;charset=utf-8" });
          FileSaver.saveAs(blob, "lekarze.csv");
        });
    },
    sendPush(){
      this.sendNotifyOpen = true;
    },
    sendNotifyClose(){
      this.sendNotifyOpen = false;
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.nowrap {
  white-space: nowrap;
}
</style>
